import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NavBarComponent } from './nav-bar/nav-bar.component'
import { DashboardComponent } from './dashboard/dashboard.component'
import { AuthGuard } from './guard/auth.guard'
import { UUIDNotFoundComponent } from './uuidnot-found/uuidnot-found.component'
import { NewUserGuard } from './uuidnot-found/new-user-guard.service'
import { DigitalSubscriptionContentComponent } from './digital-subscription-content/digital-subscription-content.component'
import { DigitalSubscriptionContentGuard } from './digital-subscription-content/digital-subscription-content-guard.service'
import { DigitalContentLinksComponent } from './digital-content-links/digital-content-links.component'
import { DigitalContentLinksGuard } from './digital-content-links/digital-content-links-guard.service'
import { ManageSubscriptionComponent } from './account/manage-subscription/manage-subscription.component'
import { ManageSubscriptionGuard } from './guard/manage-subscription.guard'
import {GroupsComponent} from "./groups/groups.component";

const routes: Routes = [
  {
    path: 'navigation',
    component: NavBarComponent,
    children: [
      { path: '', component: DashboardComponent },
      { path: 'new-user', component: UUIDNotFoundComponent, canActivate: [NewUserGuard] },
      { path: 'groups', loadChildren: () => import('./groups/groups.module').then(m => m.GroupsModule) },
      { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
      { path: 'orders', loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule) },
      {
        path: 'digital-content',
        component: DigitalSubscriptionContentComponent,
        canActivate: [DigitalSubscriptionContentGuard],
      },
      {
        path: 'digital-content-links',
        component: DigitalContentLinksComponent,
        canActivate: [DigitalContentLinksGuard],
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'manage-subscription',
    component: NavBarComponent,
    canActivate: [ManageSubscriptionGuard],
    children: [{ path: '', component: ManageSubscriptionComponent }],
  },
  { path: '**', redirectTo: 'navigation' },
]

@NgModule({
  imports: [RouterModule.forRoot(routes.filter(route => route.path !== 'login'))],
  exports: [RouterModule],
})
export class AppRoutingModule {}
